import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SettingsService } from '../settings/settings.service';
import { Meta, Title } from '@angular/platform-browser';
import { UrlService } from '../services/url.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PostHogService } from '../services/posthog.register.service';
import { ModeProdService } from '../services/mode.prod';
declare var $ :any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    standalone: false
})

export class LoginComponent implements OnInit {

  valForm: FormGroup;
  loginForm: FormGroup;
  codeForm: FormGroup;
  passwordForm: FormGroup;
  step: 'email' | 'code' = 'email';
  useOtp: boolean = false;
  passwordMode: boolean = false;
  hidePassword: boolean = true;
  hide: boolean = true;
  noCompanyAccess: boolean = false;
  disabledButton: boolean = false;
  role:any;
  showSpinner: boolean = false;
  resendCooldown: number = 0;
  private resendTimer: any;

  params:any="";
  alianza: string = '';

  constructor(
    private titleService: Title,
    private urlService: UrlService,
    private metaTagService: Meta ,
    fb: FormBuilder,
    public snackBar: MatSnackBar,
    private router: Router,
    public settings: SettingsService,
    private change:ChangeDetectorRef,
    private activated_router: ActivatedRoute,
    private posthog: PostHogService,
    public modeProd: ModeProdService

  ) {

    this.valForm = fb.group({
      'username': ['', Validators.compose([Validators.required, CustomValidators.email])],
      'beta_tester': [false]
    });

    this.loginForm = fb.group({
      'username': ['', Validators.compose([Validators.required, CustomValidators.email])],
      'password': ['', Validators.compose([Validators.required])],
      'beta_tester': [false]
    });

    this.useOtp = this.modeProd.otp_login_enabled;

    this.codeForm = fb.group({
      'code': ['', Validators.compose([Validators.required, Validators.pattern(/^[0-9]{6}$/)])]
    });

    // Filtra todo lo que no sea dígito (espacios, letras) apenas se escribe:
    // con letter-spacing en el input, un espacio colado es invisible y se come
    // uno de los 6 caracteres del maxlength, haciendo fallar el código "bien escrito".
    this.codeForm.controls['code'].valueChanges.subscribe((value: string) => {
      const sanitized = (value || '').replace(/\D/g, '').slice(0, 6);
      if (sanitized !== value) {
        this.codeForm.controls['code'].setValue(sanitized, { emitEvent: false });
      }
    });

    this.passwordForm = fb.group({
      'password': ['', Validators.required]
    });


    this.activated_router.queryParams.subscribe(params => {

      this.params = Object.keys(params)
          .map(key => `${key}=${params[key]}`)
          .join('&');

      this.alianza = params['alianza'] || '';

    });


  }

  randomImage: string = '';
  private images: string[] = [
    '../../assets/images/33.jpg',
    '../../assets/images/3.jpg',
    '../../assets/images/4.jpg',
    '../../assets/images/7.jpg',
    '../../assets/images/9.jpg',
    '../../assets/images/12.jpg',
    '../../assets/images/14.jpg',
    '../../assets/images/17.jpg',
    '../../assets/images/23.jpg',
    '../../assets/images/2.jpg',
    '../../assets/images/15.jpg',
    '../../assets/images/26.jpg',
  ];

  ngOnInit() {


    this.setRandomBackground();

    this.titleService.setTitle("Clientes Simpli");
    this.metaTagService.addTags([
      { name: 'description', content: 'Recibe liquidez para tu empresa, paga tus compromisos y accede a un ecosistema de soluciones financieras. Solo debes registrarte e ingresar a nuestra plataforma 100% digital.' },
      { name: 'keywords', content: 'factoring, financiamiento, simulaciones, operaciones, liquidez' },
      { name: 'author', content: 'Simpli S.A.' },
    ]);


    this.settings.verify_out();
    this.settings.set_initial_overflow();
    this.change.detectChanges();


  }

  setRandomBackground(): void {
    const randomIndex = Math.floor(Math.random() * this.images.length);
    this.randomImage = this.images[randomIndex];
  }

  private buildUtmValue(value: any) {
    let param = localStorage.getItem('param');
    if(param != null && param != undefined && param != ''){
      value['utm_source'] = param;
    }

    if(this.params != null && this.params != "" && this.params != undefined){
      value['utm_source'] = this.params;
    }

    return value;
  }

  switchToOtpLogin() {
    this.valForm.controls['username'].setValue(this.loginForm.controls['username'].value);
    this.loginForm.reset();
    this.useOtp = true;
  }

  switchToPasswordLogin() {
    this.loginForm.controls['username'].setValue(this.valForm.controls['username'].value);
    this.valForm.controls['username'].reset('');
    this.useOtp = false;
  }

  async submitForm($ev: any, value: any) {
    $ev.preventDefault();
    for (let c in this.loginForm.controls) {
      this.loginForm.controls[c].markAsTouched();
    }
    if (!this.loginForm.valid) {
      return;
    }

    try {
      this.showSpinner = true;

      const val: any = this.buildUtmValue({
        username: value.username,
        password: value.password,
        beta_tester: value.beta_tester,
      });

      const bd: any = await this.settings.get_query(2, 'cliente/login/', val, true);
      await this.handleLoginSuccess(bd, 'cliente/login/', value.beta_tester);

    } catch (error:any) {
      this.showSpinner = false;
      const message = error?.error?.error?.[0]?.message || 'Ocurrió un error, verifica que el email ingresado y la contraseña estén correctas.';
      this.loginForm.controls['password'].setErrors({ invalid: message });

      this.posthog.capture(
        'login',
        error?.status || 0,
        'cliente/login/',
        'Credenciales incorrectas al intentar iniciar sesión',
        'web',
      );
    }
  }

  async requestCode($ev: any, value: any) {
    $ev.preventDefault();
    this.valForm.controls['username'].markAsTouched();
    if (!this.valForm.valid) {
      return;
    }

    try {
      this.showSpinner = true;
      value = this.buildUtmValue(value);

      const bd: any = await this.settings.get_query(2, 'cliente/login/request-code/', value, true);

      this.showSpinner = false;
      this.step = 'code';
      this.startResendCooldown();

    } catch (error:any) {
      this.showSpinner = false;
      const message = error?.error?.error?.[0]?.message || 'Ocurrió un error, intenta de nuevo.';
      this.valForm.controls['username'].setErrors({ invalid: message });

      this.posthog.capture(
        'login',
        error?.status || 0,
        'cliente/login/request-code/',
        'Error al solicitar código de acceso',
        'web',
      );
    }
  }

  async resendCode() {
    if (this.resendCooldown > 0 || this.showSpinner) {
      return;
    }
    try {
      this.showSpinner = true;
      const value = this.buildUtmValue({ username: this.valForm.controls['username'].value });
      await this.settings.get_query(2, 'cliente/login/request-code/', value, true);
      this.showSpinner = false;
      this.codeForm.controls['code'].setValue('');
      this.startResendCooldown();
    } catch (error:any) {
      this.showSpinner = false;
      const message = error?.error?.error?.[0]?.message || 'No fue posible reenviar el código.';
      this.snackBar.open(message, 'Aceptar', { duration: 20000, panelClass: 'simpli-snack' });
    }
  }

  private startResendCooldown() {
    this.resendCooldown = 30;
    clearInterval(this.resendTimer);
    this.resendTimer = setInterval(() => {
      this.resendCooldown--;
      if (this.resendCooldown <= 0) {
        clearInterval(this.resendTimer);
      }
    }, 1000);
  }

  backToEmail() {
    this.step = 'email';
    this.noCompanyAccess = false;
    this.passwordMode = false;
    this.valForm.controls['username'].reset('');
    this.loginForm.reset();
    this.codeForm.reset();
    this.passwordForm.reset();
    clearInterval(this.resendTimer);
    this.resendCooldown = 0;
  }

  showPasswordLogin() {
    this.passwordMode = true;
    this.hidePassword = true;
    this.passwordForm.reset();
  }

  showCodeLogin() {
    this.passwordMode = false;
    this.passwordForm.reset();
  }

  async verifyCode($ev: any) {
    $ev.preventDefault();
    this.codeForm.controls['code'].markAsTouched();
    if (!this.codeForm.valid) {
      return;
    }

    try {
      this.showSpinner = true;

      const value: any = this.buildUtmValue({
        username: this.valForm.controls['username'].value,
        code: this.codeForm.controls['code'].value,
        beta_tester: this.valForm.controls['beta_tester'].value,
      });

      const bd: any = await this.settings.get_query(2, 'cliente/login/verify-code/', value, true);
      await this.handleLoginSuccess(bd, 'cliente/login/verify-code/', this.valForm.controls['beta_tester'].value);

    } catch (error:any) {
      this.showSpinner = false;
      const message = error?.error?.error?.[0]?.message || 'Ocurrió un error, intenta de nuevo.';
      this.codeForm.controls['code'].setErrors({ invalid: message });

      this.posthog.capture(
        'login',
        error?.status || 0,
        'cliente/login/verify-code/',
        'Error al validar código de acceso',
        'web',
      );
    }
  }

  async loginWithPassword($ev: any) {
    $ev.preventDefault();
    this.passwordForm.controls['password'].markAsTouched();
    if (!this.passwordForm.valid) {
      return;
    }

    try {
      this.showSpinner = true;

      const value: any = this.buildUtmValue({
        username: this.valForm.controls['username'].value,
        password: this.passwordForm.controls['password'].value,
        beta_tester: this.valForm.controls['beta_tester'].value,
      });

      const bd: any = await this.settings.get_query(2, 'cliente/login/', value, true);
      await this.handleLoginSuccess(bd, 'cliente/login/', this.valForm.controls['beta_tester'].value);

    } catch (error:any) {
      this.showSpinner = false;
      const message = error?.error?.error?.[0]?.message || 'Correo o contraseña incorrectos.';
      this.passwordForm.controls['password'].setErrors({ invalid: message });

      this.posthog.capture(
        'login',
        error?.status || 0,
        'cliente/login/',
        'Error al iniciar sesión con contraseña',
        'web',
      );
    }
  }

  private async handleLoginSuccess(bd: any, endpoint: string, betaTester: boolean) {
    var body_data: any = bd._body;
    var data = body_data.success.info.datos;

    localStorage.setItem('token', data.token);
    if(data.role == "conf"){
      localStorage.setItem('role', 'clie');
    }else{
      localStorage.setItem('role', data.role);
    }

    if (data.role === 'ingr') {
      this.showSpinner = false;
      localStorage.setItem('company_id', 'ingr');
      this.router.navigate(['/simulador']);
      return;
    }

    const originalUrl = this.urlService.getOriginalUrl();

    let ruta = data.ruta;


    if(data?.informacion_company?.company_id != undefined){

      localStorage.setItem('company_id', data.informacion_company.company_id);
      localStorage.setItem('business_name', data.informacion_company.business_name);
      localStorage.setItem('rut', data.informacion_company.rut);


      //identificamos el usuario en posthog
      this.posthog.identify(
        data.informacion_company.company_id,
        data.informacion_company.rut,
        data.informacion_company.business_name
      );

      //capturamos el evento
      this.posthog.capture(
        'login',
        200,
        endpoint,
        'El usuario inició sesión con éxito',
        'web',
      );


      if(betaTester == true){
        location.replace(SettingsService.cliente_nuevo +'dashboard?token='+localStorage.getItem('token')+'&company_id='+data.informacion_company.company_id);
        return;
      }


      if(originalUrl == '' && ruta == null){
        this.router.navigate(['home']);
      }else if(originalUrl == ''){
        this.router.navigate([ruta]);
      }else if(ruta == "portales"){
        this.router.navigate([ruta]);
      }else if(originalUrl != '' && originalUrl != null && originalUrl != undefined){
         this.router.navigateByUrl(originalUrl);
      }else if(originalUrl.includes('home/onboarding') && ruta == 'home'){
        this.router.navigate([ruta]);
      }else if(ruta == null){
        this.router.navigate(['home'])
      }else{
        this.router.navigateByUrl(originalUrl);
      }

      localStorage.removeItem('param');

      this.change.detectChanges();

    }else{
      this.empresasRelacionadas(ruta)
    }

    this.showSpinner = false;
  }

  contactar_cx(){
    window.open('https://api.whatsapp.com/send/?phone=%2B56934677786&text&type=phone_number&app_absent=0', '_blank')
  }

  async empresasRelacionadas(ruta:any) {
    try {
      const bd: any = await this.settings.get_query(1, 'cliente/empresas-relacionadas/?limit=1');
      var body_data: any =bd._body;
      var data = body_data.success.info;
      switch (bd.status) {
        case 200:
          if (data.length === 0) {
            this.noCompanyAccess = true;
            this.showSpinner = false;
            break;
          }
          if (data.length > 0) {


            let empresa_obj = data[0];

            localStorage.setItem('company_id', empresa_obj.company_id.toString());
            localStorage.setItem('business_name', empresa_obj.business_name)

            const originalUrl = this.urlService.getOriginalUrl();


            if(originalUrl == '' && ruta == null){
              this.router.navigate(['home']);
            }else if(originalUrl == ''){
              this.router.navigate([ruta]);
            }else if(ruta == "portales"){
              this.router.navigate([ruta]);
            }else if(ruta == null){

              this.router.navigate(['home'])

            }else{
              this.router.navigateByUrl(originalUrl);
            }



            localStorage.removeItem('param');

            this.change.detectChanges();
          }
        break;
        default:

        break;
      }
    } catch (bd:any) {
      this.settings.manage_errors(bd.status, 'Set empresa local storage', bd, false);
    }
  }

}
